import { API } from "."
import {
  ReadAccelZonesResponse,
  ReadDecelZonesResponse,
  ReadGlobalZonesResponse,
  ReadHrZonesResponse,
  ReadPlayerCustomMetricHistoryParams,
  ReadPlayerCustomMetricHistoryResponse,
  ReadSpeedZonesResponse,
  UpsertSettingAccelZoneActivePayload,
  UpsertSettingAccelZonePayload,
  UpsertSettingDecelZoneActivePayload,
  UpsertSettingDecelZonePayload,
  UpsertSettingHrZoneActivePayload,
  UpsertSettingHrZonePayload,
  UpsertSettingSpeedZoneActivePayload,
  UpsertSettingSpeedZonePayload,
} from "@/types/zone"

export async function readGlobalZones() {
  return await API.get<ReadGlobalZonesResponse>("/settings/zone")
}

/* Speed */
export async function readSpeedZones() {
  return await API.get<ReadSpeedZonesResponse>("/settings/zone/speed")
}

export async function upsertSpeedZones(payload: UpsertSettingSpeedZonePayload) {
  return await API.put<void>("/settings/zone/speed", payload)
}

export async function upsertPlayerMetricSpeedActive(payload: UpsertSettingSpeedZoneActivePayload) {
  return await API.put<void>("/settings/zone/speed/active", payload)
}

/* Accel */
export async function readAccelZones() {
  return await API.get<ReadAccelZonesResponse>("/settings/zone/accel")
}

export async function upsertAccelZones(payload: UpsertSettingAccelZonePayload) {
  return await API.put<void>("/settings/zone/accel", payload)
}

export async function upsertPlayerMetricAccelActive(payload: UpsertSettingAccelZoneActivePayload) {
  return await API.put<void>("/settings/zone/accel/active", payload)
}

/* Decel */
export async function readDecelZones() {
  return await API.get<ReadDecelZonesResponse>("/settings/zone/decel")
}

export async function upsertDecelZones(payload: UpsertSettingDecelZonePayload) {
  return await API.put<void>("/settings/zone/decel", payload)
}

export async function upsertPlayerMetricDecelActive(payload: UpsertSettingDecelZoneActivePayload) {
  return await API.put<void>("/settings/zone/decel/active", payload)
}

/* HR */
export async function readHrZones() {
  return await API.get<ReadHrZonesResponse>("/settings/zone/hr")
}

export async function upsertHrZones(payload: UpsertSettingHrZonePayload) {
  return await API.put<void>("/settings/zone/hr", payload)
}

export async function upsertPlayerMetricHrActive(payload: UpsertSettingHrZoneActivePayload) {
  return await API.put<void>("/settings/zone/hr/active", payload)
}

/* Custom */
export async function readPlayerCustomMetricHistory(params: ReadPlayerCustomMetricHistoryParams) {
  const { idfPlayer, metric } = params

  return await API.get<ReadPlayerCustomMetricHistoryResponse>(
    `/settings/zone/${metric}/history/custom/players/${idfPlayer}`,
  )
}
